<template>
    <div style="width: 100%; height: 100%;">
        <div ref="mnv-result-saving" style="width: 100%; height: 100%"></div>
    </div>
</template>

<script>
import * as echarts from "echarts";

export default {
    props: ["mnvReportData", "reportKey"],
    data() {
        return {
            chart: null,
        };
    },
    watch: {
        mergeDetails() {
            this.renderChart();
        },
    },
    computed: {
        mainKey2() {
            return this.mnvReportData.variable.main.map((item) => item.key);
        },
        mergeDetails() {
            const detailsArrays = this.mainKey2.map(
                (key) => this.mnvReportData.analysisOverview[key].report?.details || []
            );
            const maxLength = Math.max(...detailsArrays.map((details) => details.length));

            return Array.from({ length: maxLength }, (_, index) => {
                return detailsArrays.reduce((merged, details) => {
                    const item = details[index] || {};
                    Object.keys(item).forEach((key) => {
                        merged[key] = this.formatNumber((merged[key] || 0) + item[key]);
                    });
                    return merged;
                }, {});
            });
        },
    },
    mounted() {
        this.renderChart();
    },
    methods: {
        formatNumber(num) {
            console.log("typeof num", typeof num, num);
            if (Number.isInteger(num)) {
                return num;
            }

            const decimalPart = num.toString().split(".")[1] || "";

            if (decimalPart.length === 1) {
                return num;
            }

            return parseFloat(num.toFixed(2));
        },
        //상위컴포넌트에서 탭전환에 따른 차트 리사이즈를 위한 함수
        resizeChart() {
            if (this.chart) {
                this.chart.resize();
            }
        },
        formatYAxisValue(value) {
            if (value >= 1000000) {
                return (value / 1000000).toFixed(1) + "M";
            } else if (value >= 1000) {
                return (value / 1000).toFixed(1) + "k";
            } else {
                return value;
            }
        },
        renderChart() {
            this.chart = echarts.init(this.$refs["mnv-result-saving"]);

            // const details = this.mnvReportData.analysisOverview[this.mainKey].report.details;

            const option = {
                title: {
                    text: "절감량 비교",
                    left: "left",
                    textStyle: {
                        fontSize: 11,
                    },
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                    },
                },
                legend: {
                    data: ["측정", "베이스라인"],
                    bottom: "0%",
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "10%",
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    // data: details.map((_, i) => `${i + 1}`),
                    data: this.mergeDetails.map((_, i) => `${i + 1}`),
                },
                yAxis: {
                    type: "value",
                    axisLabel: {
                        formatter: this.formatYAxisValue,
                    },
                },
                series: [
                    {
                        name: "측정",
                        type: "bar",
                        data: this.mergeDetails.map((item) => item.measure),
                        color: "#5BAF32",
                    },
                    {
                        name: "베이스라인",
                        type: "bar",
                        data: this.mergeDetails.map((item) => item.predict),
                        color: "#5470C6",
                    },
                ],
            };

            this.chart.setOption(option);

            window.addEventListener("resize", () => {
                this.chart.resize();
            });
        },
    },
};
</script>
